import { parse, isValid, parseISO, format, subDays, isBefore, startOfDay } from 'date-fns';

export const LOCAL_STORAGE_NOTIFICATION_STATUS = 'notification_status';
export const LOCAL_STORAGE_OTP_RECIPIENTS = 'local_storage_otp_recipients';
export enum fromRole {
  SB_CREATOR = 'sbcreator',
  RECIPIENT = 'recipient',
  SB_PERFORMER = 'sbperformer',
  SB_EXTERNAL_RECIPIENT = 'ext_recipient',
  PROFILE_VIEWER = 'profile_viewer',
}
export enum SbStatusMaster {
  open = 'open',
  pending_review = 'pending_review',
  locked = 'locked',
  expired = 'expired',
}

export const SbStatusMasterKeyValue: OptionProps[] = [
  { id: SbStatusMaster.open, name: 'In Progress' },
  { id: SbStatusMaster.pending_review, name: 'Selection Mode' },
  { id: SbStatusMaster.locked, name: 'Locked' },
  { id: SbStatusMaster.expired, name: 'Expired' },
];

export const SbStatusMasterColorKeyValue: OptionProps[] = [
  { id: SbStatusMaster.open, name: 'green' },
  { id: SbStatusMaster.pending_review, name: 'blue' },
  { id: SbStatusMaster.locked, name: 'pink' },
  { id: SbStatusMaster.expired, name: 'sky-blue' },
];


export const UserBgColors = [
  '#BCEDFB',
  '#BCFBE0',
  '#E2F7C4',
  '#FFE8D4',
  '#FFD4F3',
  '#EFD4FF',
  '#E0D4FF',
  '#D4E8FF',
];
export const UserColors = [
  '#008AA9',
  '#00A963',
  '#65A900',
  '#E5713B',
  '#DD5595',
  '#B759DC',
  '#9061E2',
  '#4768D0',
];
export const SbStatusMasterKeyValueSelect: OptionProps[] = [
  { id: 'All', name: 'All' },
  ...SbStatusMasterKeyValue,
];

export enum ProfileStatusMaster {
  Pending = 0,
  Selected = 1,
  Rejected = 2,
  BackupSelected = 3,
  Onboard = 4,
}

export enum RecipientProfileStatusMaster {
  Pending = 0,
  Liked = 1,
  Unliked = 2,
}

export enum KitDocumentType {
  Image = 1,
  Video = 2
}


export interface CustomTabModal {
  id: number;
  name: string;
  show: boolean;
}
export interface ProjectModel {
  id: number;
  title: string;
  project_type: string;
  season: number;
  starting_episode: number;
  // created_at: string;
  // updated_at: string;
  // deleted_at: string;
  block_shooting: string;
  starting_block: string;
  episodes_in_block: string;
  position: number;
  uuid: string;
  // external_calendar_id : string;
  // v3_calendar_id: string;
  project_image_thumb: string;
}
export interface EpisodeModel {
  id: number;
  project_id: number;
  name: string;
  episode_number: number;
  uuid: string;
  subscription_tier: string;
  role?: string;
}

export interface SbCurrentUser {
  id: number;
  uuid: string;
  email: string;
  first_name: string;
  last_name: string;
  measure_system: string;
  subscription_tier: string;
  role?: string;
  imageUrl?: string;
  croppedAvatarUrl?: string;
  super_admin?: boolean;
  // following parameters are for external selector
  key_token?: string;
  otp_valid?: string;
  sb_recipient?: SbRecipientModel;
}
export interface SbRecipientModel {
  id: number;
  key_token?: string;
  otp_valid?: string;
  recipient_email: string;
  submission_board_id: number;
  user_id?: number;
}


export interface OptionProps {
  id: number | string; // may be number or string
  name: string;
  role?: string;
}


export type SubmissionBoardFilter = {
  keyword?: string;
  // showExpired?: number;
  sb_status?: string;
};

export type SubmissionBoardModel = {
  id: number;
  header?: string;
  project_folder_uuid?: string;
  scene_card_uuid?: string;
  episode_name?: string;
  scene_name?: string;
  title: string;
  requirements?: any;
  multiple_hire: number;
  sb_status: string;
  project_id: number;
  created_by: number;
  owner_id?: number;
  owner_name?: string;
  created_at: string;
  expire_at: string;
  is_recipient_otp?: boolean;
  total_profiles: number;
  total_profiles_pending: number;
  total_profiles_onboard: number;
  total_profiles_rejected: number;
  recipients?: RecipientsModel[];
  profiles?: any;
  coordinators?: CoordinatorsModel[];
  super_coordinator_name?: string;
  project?: any; // for performer
  is_multiple_hire?: boolean; // for UI
  media_requests?: any; // for performer
  submission_kit_tags?: SubmissionKitTagsModel[];
  request: number; // total media request pending
};

export type RecipientsModel = {
  id: number; // user_id if present, for external selector it is null
  sb_recipient_id: number;
  name: string;
  email: string;
  imageUrl: string;
};
export type CoordinatorsModel = {
  user_id: number;
  name: string;
  email: string;
  role: string;
  imageUrl: string;
};
export type InvitePerformerModel = {
  email: string;
  first_name: string;
  last_name: string;
};

export type ProfileModel = {
  id: number;
  uuid: string;
  firstName: string;
  lastName: string;
  email: string;
  cell_phone: string;
  gender: string;
  measure_system: 'imperial' | 'metric';
  height_ft: number;
  height_in: number;
  height: number;
  weight: number;
  weight_lbs: number;
  country: string;

  imageUrl: string;
  croppedAvatarUrl: string;
  is_fav?: boolean;
};

export interface NoteData {
  id: number;
  note_text: string;
  user_id: number;
  sb_recipient_id: number;
  user_name: string;
  note_role: string;
  created_at: string;
}

export type SubmissionKitTagsModel = {
  name: string;
  filetype: number; // 1: image. 2:video
};

export const isExpired = (expire_at: Date | string): boolean => {
  if (expire_at == undefined || expire_at == null || expire_at == '') {
    return false;
  }
  let date = null;
  if (typeof expire_at === 'string') {
    const date1 = parseISO(expire_at);
    if (isValid(date1)) {
      date = date1;
    }
  } else {
    date = expire_at;

  }
  const startOfToday = startOfDay(new Date());
  const startOfDateToCheck = startOfDay(date);
  return isBefore(startOfDateToCheck, startOfToday);
  // if (date < new Date()) {
  //   return true;
  // }
  // return false;
};

export const isXDaysOlder = (dateToCheck, numberOfDays, referenceDate = new Date()) => {
  if (dateToCheck == undefined || dateToCheck == null || dateToCheck == '') {
    return true;
  }
  let date = null;
  if (typeof dateToCheck === 'string') {
    const date1 = parseISO(dateToCheck);
    if (isValid(date1)) {
      date = date1;
    }
  } else {
    date = dateToCheck;
  }
  const sevenDaysAgo = subDays(referenceDate, numberOfDays);
  return isBefore(date, sevenDaysAgo);// || dateToCheck.getTime() === sevenDaysAgo.getTime();
}

export const getDateString = (inputDate: Date | string, formatDate: string): string => {
  if (inputDate === undefined || inputDate === null) {
    return '';
  }
  let date = null;
  if (typeof inputDate === 'string') {
    date = parse(inputDate, formatDate, new Date());
  } else {
    date = inputDate;
  }
  if (isValid(date)) {
    return format(date, formatDate);
  } else if (typeof inputDate === 'string') {
    const date1 = parseISO(inputDate);
    if (isValid(date1)) {
      return format(date1, formatDate);
    }
  }

  return '';
};

export const getProfileHeightString = (user: ProfileModel, currentUser: SbCurrentUser) => {
  let measure_system = 'imperial';
  if (!isUndefinedNullEmpty(currentUser) && !isUndefinedNullEmpty(currentUser.measure_system)) {
    measure_system = currentUser.measure_system;
  }
  // console.log('getProfileHeightString currentUser', currentUser , 'profile', user,
  //   "measure_system",measure_system
  // )
  if ((measure_system == 'imperial')
    && user.height_ft > 0
  ) {
    // console.log('user', user.height_ft + '" ' + user.height_in + '\' ' )
    return user.height_ft + '\' ' + user.height_in + '" ';
  } else if (user.height) {
    return user.height + ' cm';
  }
  return '';
};
export const getProfileWeightString = (user: ProfileModel, currentUser: SbCurrentUser) => {
  let measure_system = 'imperial';
  if (!isUndefinedNullEmpty(currentUser) && !isUndefinedNullEmpty(currentUser.measure_system)) {
    measure_system = currentUser.measure_system;
  }
  // console.log('getProfileHeightString currentUser', currentUser , 'profile', user,
  //   "measure_system",measure_system
  // )
  if ((measure_system == 'imperial') && user.weight_lbs > 0) {
    return user.weight_lbs + ' lbs';
  } else if (user.weight) {
    return user.weight + ' kg';
  }
  return '';
};

export const humanize = (stringValue) => {
  if (typeof stringValue !== 'string' || stringValue == undefined || stringValue == null) {
    return stringValue;
  }
  const words = stringValue
    .trim()
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/\-/g, ' ').split(/\s+/);
  const humanizedWords = words.map((word) => {
    if (word.length > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
    return ''; // Return an empty string for any empty words
  });
  return humanizedWords.join(' ');

  // return stringValue
  //   .replace(/^[\s_]+|[\s_]+$/g, '')
  //   .replace(/[_\s]+/g, ' ')
  //   .replace(/\-/g, ' ')
  //   .replace(/^[a-z]/, function (item) {
  //     return item.toUpperCase();
  //   });
};
export const getSbStatusString = (sb_status: string) => {
  const itemSelected = SbStatusMasterKeyValue.find((item) => item.id == sb_status);
  if (itemSelected) {
    return itemSelected.name;
  }
  return '';
};
export const getSbStatusColorString = (sb_status: string) => {
  const itemSelected = SbStatusMasterColorKeyValue.find((item) => item.id == sb_status);
  if (itemSelected) {
    return itemSelected.name;
  }
  return '';
};
export const getSbStatusStringWithCounts = (item: SubmissionBoardModel) => {
  const status = getSbStatusString(item.sb_status);
  const totalProfiles = item.total_profiles || 0;
  const totalAccepted = item.total_profiles_onboard || 0;
  // Don't show counts for locked status
  if (item.sb_status === 'locked') {
    if (totalAccepted > 0) {
      return `${status} ( ${totalAccepted} selected)`;
    }
    return status;
  }
  // Don't show counts if no profiles
  if (totalProfiles === 0) {
    return status;
  }
  // Show simplified format: Status (added to team count/total)
  return `${status} (${totalAccepted}/${totalProfiles} selected )`;
};

export const getUserBgColorsRandom = (index?: number) => {
  if (index == undefined || index < 0) {
    index = Math.floor(Math.random() * 8);
  }
  if (index < UserBgColors.length) {
    return UserBgColors[index];
  }
  return '';
};
export const getUserColorsRandom = (index?: number) => {
  if (index == undefined || index < 0) {
    index = Math.floor(Math.random() * 8);
  }
  if (index < UserColors.length) {
    return UserColors[index];
  }
  return '';
};

export const saveStorageNotification = (sb_creator: string, status: number) => {
  const storedUsersString = localStorage.getItem(LOCAL_STORAGE_NOTIFICATION_STATUS);
  let storedUsers: any = {};
  if (storedUsersString) {
    storedUsers = JSON.parse(storedUsersString);
  }
  storedUsers[sb_creator] = status;
  // console.log('set storedUsers', storedUsers); // const updatedUsers = [...storedUsers];
  localStorage.setItem(LOCAL_STORAGE_NOTIFICATION_STATUS, JSON.stringify(storedUsers));
};
export const getStorageNotification = (sb_creator: string) => {
  const storedUsersString = localStorage.getItem(LOCAL_STORAGE_NOTIFICATION_STATUS);
  if (storedUsersString) {
    let storedUsers = JSON.parse(storedUsersString);
    // console.log('get storedUsers', storedUsers);
    return storedUsers[sb_creator] ?? 1;
  }
  // console.log('get storedUsers: 1');
  return 1;
};


export const isUndefinedNullEmpty = (value: string | any) => {
  if (value == null) {
    return true;
  }
  if (typeof value === 'string' && value.trim() === '') {
    return true;
  }
  return false;
};